module.exports = __webpack_public_path__ + "static/media/aspirinCommon.51a15049.mp3";